module.exports = {"360402001":"十里街道","360402002":"五里街道","360402090":"七里湖街道（九江经济技术开发区）","360402100":"姑塘镇","360402101":"威家镇","360402102":"新港镇","360402103":"莲花镇","360402105":"赛阳镇","360402200":"虞家河乡","360402201":"高垅乡","360402471":"庐山林科所","360402472":"庐山生态文化新城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360402.json
// module id = 1264
// module chunks = 0